<div class="modern-upload" (click)="triggerFileSelect(fileInput)">
  <span class="modern-icon">📁</span>
  <p class="modern-text">Click or drag file to upload</p>
  <input
    #fileInput
    type="file"
    (change)="onFileSelected($event)"
    accept="{{selectedFileExtention}}"
    [attr.multiple]="selectedHeader === 'Merge PDF' || selectedHeader === 'Image to PDF' ? true : null"
    hidden
  />
</div>
